package com.sweetlime.bingeamigo.presentation.ui

import androidx.compose.ui.graphics.Color

object BrandColors {
    // Brand
    val Primary   = Color(0xFFFFB800)
    val Secondary = Color(0xFF00B8B8)

    // Backgrounds
    val Background        = Color(0xFF121212)
    val BackgroundDeep    = Color(0xFF0D0D0D)
    val Surface           = Color(0xFF1C1C1C)
    val SurfaceElevated   = Color(0xFF1E1E1E)
    val Card              = Color(0xFF1A1A1A)
    val CardElevated      = Color(0xFF222222)

    // Text / icons
    val TextPrimary   = Color.White
    val TextSecondary = Color(0xFF888888)

    // Semantic
    val Favorite = Color(0xFFE05C7A)
    val Error    = Color(0xFFCF6679)
}